import { cn } from "@/lib/utils";

/**
 * Placeholder rectangle. Uses the `.shimmer` utility from app.css — a
 * warm sweeping gradient that runs at 1.6s, matching design-system §5.3.
 * Reduced-motion falls back to a static `--bg-sunken` fill (also handled
 * inside app.css).
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("shimmer rounded-md", className)}
      aria-hidden
      {...props}
    />
  );
}
